import { joinPhrase, type Hand, type Join, type Key, type Line, type Tables } from 'ErgoBot';
import type { HandLines } from './handLines';
import type { HandStates } from './phraseFingering';

/** Nothing stands between the hands and the phrase. */
const FREE_JOIN: Join = { compatible: true, hops: 0 };

const HANDS: ReadonlyArray<Hand> = ['rh', 'lh'];

/**
 * Whether the hands can get into a phrase, in the key it sounds in, from where
 * the phrase before it left them, and how many hops that takes: the check
 * phrase selection makes when it is sent the hands' states. A phrase without a
 * tier and a hand whose staff cannot be read as one line are not judged: they
 * get no finger numbers either.
 */
export const joinOfPhraseNotes = (
  tables: Tables,
  tier: string | null,
  lines: HandLines,
  states: HandStates,
  key: Key,
): Join => {
  if (tier === null) return FREE_JOIN;
  const readable = HANDS.reduce<Partial<Record<Hand, Line>>>((judged, hand) => {
    const handLine = lines[hand];
    return handLine === null ? judged : { ...judged, [hand]: handLine.line };
  }, {});
  return joinPhrase(tables, tier, states, readable, key);
};
